module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-2-svgrepo-com.e495a224.svg";